import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X } from "@phosphor-icons/react";
import logo from "@/logo_full_light.png";

const LINKS = [
  { label: "Servizi", id: "servizi" },
  { label: "Metodo", id: "metodo" },
  { label: "Showreel", id: "showreel" },
  { label: "Contatti", id: "contatti" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, delay: 1.5, ease: [0.16, 1, 0.3, 1] }}
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-brand-dark/85 backdrop-blur-xl border-b border-brand-border" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <button onClick={() => go("top")} data-testid="nav-logo" className="flex items-center group">
          <img src={logo} alt="New Graphic — Visual Communication" className="h-9 lg:h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="relative text-sm font-outfit uppercase tracking-widest text-neutral-300 hover:text-white transition-colors group"
            >
              {l.label}
              <span className="absolute -bottom-1.5 left-0 h-[2px] w-0 bg-brand-red group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </nav>

        <button
          onClick={() => go("contatti")}
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center bg-brand-red text-white text-sm font-outfit font-semibold uppercase tracking-wider px-6 py-3 rounded-full hover:bg-white hover:text-brand-dark transition-colors duration-300"
        >
          Preventivo
        </button>

        <button onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" className="md:hidden text-white">
          {open ? <X size={28} weight="bold" /> : <List size={28} weight="bold" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-brand-dark border-b border-brand-border"
          >
            <div className="flex flex-col px-6 py-6 gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  onClick={() => go(l.id)}
                  data-testid={`mobile-nav-link-${l.id}`}
                  className="text-left text-2xl font-anton uppercase text-neutral-200"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
